//absolute imports to be fixed for test suits
import {
  KeyboardArrowDown,
  TrendingFlatOutlined,
  Refresh,
  Lock,
  Email,
  Close,
  InfoOutlined,
  VisibilityOff,
  Visibility,
  ExpandMore,
  ExpandLess,
  KeyboardDoubleArrowRight,
  KeyboardDoubleArrowLeft,
  KeyboardArrowRight,
  KeyboardArrowLeft,
} from "@mui/icons-material";
import {
  FarmIcon,
  CropIcon,
  LandIcon,
  SearchIcon,
  UserIcon,
  ArrowRise,
  ArrowFall,
  SummaryIcon,
  Folder,
  Export,
  ExpandIcon,
  CollapseIcon,
  Logout,
  ExpandNavigate,
  CollapseNavigate,
  NavigatePrev,
  NavigateNext,
  FilterIcon,
  SortIcon,
  HourGlassIcon,
  CloseIcon,
  Correct,
  Wrong,
  Disable,
  DeactivateUser,
  MinusIcon,
  PlusIcon,
  AddAgentIcon,
  MaageSurveyAgentsIcon,
  DangerIcon,
} from "./components/Icon";
import { MouseEventHandler } from "react";
import { IconReturnType, IconType } from "./components/type.types";

const Icon: IconReturnType = {
  key: () => <Lock />,
  email: () => <Email />,
  Overview: ({ width, height, color, strokeColor }: IconType) => (
    <SummaryIcon
      width={width}
      height={height}
      color={color}
      strokeColor={strokeColor}
    />
  ),
  "Manage Farmers": ({
    width,
    height,
    color,
    strokeWidth,
    strokeColor,
    circle,
  }: IconType) => (
    <UserIcon
      width={width}
      height={height}
      color={color}
      strokeWidth={strokeWidth}
      strokeColor={strokeColor}
      circle={circle}
    />
  ),
  "Manage Survey Agents": ({
    width,
    height,
    color,
    strokeWidth,
    strokeColor,
  }: IconType) => (
    <MaageSurveyAgentsIcon
      width={width}
      height={height}
      color={color}
      strokeWidth={strokeWidth}
      strokeColor={strokeColor}
    />
  ),
  "Custom Reports": ({
    width,
    height,
    color,
    strokeWidth,
    strokeColor,
  }: IconType) => (
    <Folder
      width={width}
      height={height}
      color={color}
      strokeWidth={strokeWidth}
      strokeColor={strokeColor}
    />
  ),

  export: ({ width, height, color }: IconType) => (
    <Export width={width} height={height} color={color} />
  ),
  increaseTrend: ({ width, height, color }: IconType) => (
    <ArrowRise width={width} height={height} color={color} />
  ),
  decreseTrend: ({ width, height, color }: IconType) => (
    <ArrowFall width={width} height={height} color={color} />
  ),
  farmIconWithCircle: ({ width, height, color, strokeColor }: IconType) => (
    <FarmIcon
      width={width}
      height={height}
      color={color}
      strokeColor={strokeColor}
    />
  ),
  farmerIcon: ({
    width,
    height,
    color,
    circle,
    strokeWidth,
    strokeColor,
  }: IconType) => (
    <UserIcon
      width={width}
      height={height}
      color={color}
      circle={circle}
      strokeWidth={strokeWidth}
      strokeColor={strokeColor}
    />
  ),
  landIconWithCircle: ({ width, height, color, strokeColor }: IconType) => (
    <LandIcon
      width={width}
      height={height}
      color={color}
      strokeColor={strokeColor}
    />
  ),
  cropIconWithCircle: ({ width, height, color, strokeColor }: IconType) => (
    <CropIcon
      width={width}
      height={height}
      color={color}
      strokeColor={strokeColor}
    />
  ),
  farmIcon: ({ width, height, color, circle, strokeColor }: IconType) => (
    <FarmIcon
      width={width}
      height={height}
      color={color}
      circle={circle}
      strokeColor={strokeColor}
    />
  ),
  landIcon: ({ width, height, color, circle, strokeColor }: IconType) => (
    <LandIcon
      width={width}
      height={height}
      color={color}
      circle={circle}
      strokeColor={strokeColor}
    />
  ),
  cropIcon: ({ width, height, color, circle, strokeColor }: IconType) => (
    <CropIcon
      width={width}
      height={height}
      color={color}
      circle={circle}
      strokeColor={strokeColor}
    />
  ),
  search: ({ width, height, color }: IconType) => (
    <SearchIcon width={width} height={height} color={color} />
  ),
  dropDown: ({ color = "black" }: { color?: string }) => (
    <KeyboardArrowDown
      sx={{
        width: "1rem",
        height: "1rem",
        cursor: "pointer",
        color: color ?? "black",
      }}
      data-cy="drop-down"
    />
  ),
  expand: ({ width, height, color }: IconType) => (
    <ExpandIcon width={width} height={height} color={color} />
  ),
  collapse: ({ width, height, color }: IconType) => (
    <CollapseIcon width={width} height={height} color={color} />
  ),
  logout: ({ width, height, color }: IconType) => (
    <Logout width={width} height={height} color={color} />
  ),
  FlatTrend: () => (
    <TrendingFlatOutlined
      sx={{ width: "1rem", height: "1rem" }}
      data-testid="flat-trend-icon"
    />
  ),
  refresh: (refetchHandler: MouseEventHandler) => (
    <Refresh
      onClick={(event) => {
        refetchHandler(event);
      }}
      sx={{ cursor: "pointer" }}
      data-testid="refresh-icon"
    />
  ),
  close: () => <Close />,
  ExpandNavigate: ({ width, height, color, onClick, id, dataCy }: IconType) => (
    <ExpandNavigate
      width={width}
      height={height}
      color={color}
      id={id}
      onClick={onClick}
      dataCy={dataCy}
    />
  ),
  CollapseNavigate: ({ width, height, color, onClick }: IconType) => (
    <CollapseNavigate
      width={width}
      height={height}
      color={color}
      onClick={onClick}
    />
  ),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Info: (onMouseEnter: MouseEventHandler, sx: any) => (
    <InfoOutlined onMouseEnter={onMouseEnter} sx={{ ...sx }} />
  ),
  NavigateNext: ({ width, height, color, onClick }: IconType) => (
    <NavigateNext
      onClick={onClick}
      width={width}
      height={height}
      color={color}
    />
  ),
  NavigatePrev: ({ width, height, color, onClick }: IconType) => (
    <NavigatePrev
      onClick={onClick}
      width={width}
      height={height}
      color={color}
    />
  ),

  FilterIcon: ({ width, height, color, onClick, fill }: IconType) => (
    <FilterIcon
      onClick={onClick}
      width={width}
      height={height}
      color={color}
      fill={fill}
    />
  ),
  VisibilityOff: (onPasswordIconClick: MouseEventHandler) => (
    <VisibilityOff onClick={onPasswordIconClick} sx={{ cursor: "pointer" }} />
  ),
  VisibilityOn: (onPasswordIconClick: MouseEventHandler) => (
    <Visibility onClick={onPasswordIconClick} sx={{ cursor: "pointer" }} />
  ),
  SortableIcon: ({ width, height, color, onClick, increasing }: IconType) => (
    <SortIcon
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      increasing={increasing}
    />
  ),
  ExpandMore: ({
    onClick,
    width,
    height,
    color,
  }: {
    onClick?: React.MouseEventHandler;
    width: number;
    height: number;
    color: string;
  }) => {
    return (
      <ExpandMore
        onClick={onClick}
        sx={{
          width: `${width}`,
          height: `${height}`,
          strokeWidth: 0.5,
          cursor: "pointer",
          color: `${color}`,
        }}
      />
    );
  },
  ExpandLess: ({
    onClick,
    width,
    height,
    color,
  }: {
    onClick: React.MouseEventHandler;
    width: number;
    height: number;
    color: string;
  }) => {
    return (
      <ExpandLess
        onClick={onClick}
        sx={{
          width: `${width}`,
          height: `${height}`,
          strokeWidth: 0.5,
          cursor: "pointer",
          color: `${color}`,
        }}
      />
    );
  },
  NextPage: () => <KeyboardArrowRight sx={{ cursor: "pointer" }} />,
  PrevPage: () => <KeyboardArrowLeft sx={{ cursor: "pointer" }} />,
  SkipPageNext: ({
    onClick,
    color,
  }: {
    onClick?: React.MouseEventHandler;
    color: string;
  }) => (
    <KeyboardDoubleArrowRight
      onClick={onClick}
      sx={{
        cursor: color !== "black" ? "not-allowed" : "pointer",
        color: color,
      }}
    />
  ),
  SkipPagePrev: ({
    onClick,
    color,
  }: {
    onClick?: React.MouseEventHandler;
    color: string;
  }) => (
    <KeyboardDoubleArrowLeft
      onClick={onClick}
      sx={{
        cursor: color !== "black" ? "not-allowed" : "pointer",
        color: color,
      }}
    />
  ),
  HourglassIcon: ({ color, width, height }: IconType) => {
    return <HourGlassIcon color={color} width={width} height={height} />;
  },
  CloseIcon: ({ onClick, width, height, color }: IconType) => {
    return (
      <CloseIcon
        color={color}
        width={width}
        height={height}
        onClick={onClick}
      />
    );
  },
  Correct: ({ color, width, height }: IconType) => {
    return <Correct color={color} width={width} height={height} />;
  },
  Wrong: ({ color, width, height }: IconType) => {
    return <Wrong color={color} width={width} height={height} />;
  },
  Disable: ({ color, width, height }: IconType) => {
    return <Disable color={color} width={width} height={height} />;
  },
  DeactivateUser: ({ color, width, height }: IconType) => {
    return <DeactivateUser color={color} width={width} height={height} />;
  },
  Minus: ({ color, width, height }: IconType) => {
    return <MinusIcon width={width} height={height} color={color} />;
  },
  Plus: ({ color, width, height }: IconType) => {
    return <PlusIcon width={width} height={height} color={color} />;
  },
  AddAgent: ({ color, width, height }: IconType) => {
    return <AddAgentIcon color={color} width={width} height={height} />;
  },
  Danger: ({ color, width, height }: IconType) => {
    return <DangerIcon color={color} width={width} height={height} />;
  },
};
export default Icon;
